const EqualSignIcon = /*#__PURE__*/ [
  ["path", { d: "M4 8H20", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 16H20", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export { EqualSignIcon as default };
//# sourceMappingURL=EqualSignIcon.js.map
